import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useTheme } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setUrlParams } from '../../../../utils/helpers/urlParams';
import { routePaths } from '../../../../routePaths';
import { refetchRossumUploadsByWarehouseIdQuery, refetchRossumUploadsCountByWarehouseIdQuery, useUploadInvoicesMutation } from '../../../../generated/graphql';
import { useWarehousesScope } from '../../../warehouse/providers/WarehouseScopeProvider';
import UploadDeliveryListDialog from './UploadDeliveryListDialog';

const UploadDeliveryListForm = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const theme = useTheme();

    const { currentWarehouseId } = useWarehousesScope();

    const [isDialogOpened, setIsDialogOpened] = useState(true);

    const [uploadInvoices] = useUploadInvoicesMutation({
        refetchQueries: [
            refetchRossumUploadsByWarehouseIdQuery({ warehouseId: currentWarehouseId as string }),
            refetchRossumUploadsCountByWarehouseIdQuery({ warehouseId: currentWarehouseId as string }),
        ],
    });

    const dialogName = t('Upload invoices');

    const onClose = () => {
        setIsDialogOpened(false);

        setTimeout(() => {
            history.push(routePaths.warehouseDeliveryLists);

            const urlParams = setUrlParams(history.location.search, {
                showInProcess: true,
            });
            history.push({ search: urlParams.toString() });
        }, theme.transitions.duration.leavingScreen);
    };

    const onUpload = (files: File[]) => {
        uploadInvoices({ variables: { files, warehouseId: currentWarehouseId as string } })
            .catch(e => toast(e.message, { type: 'error' }));
    };

    return (
        <UploadDeliveryListDialog
            dialogName={dialogName}
            isOpened={isDialogOpened}
            onClose={onClose}
            onUpload={onUpload}
        />
    );
};

export default UploadDeliveryListForm;
